define('controllers/mysetting/namechange/name-change-mod-bussiness.ctrl',['app'], function (app) {
    app.controller('NameChangeModBussnessInfo', ['$q', '$scope', '$state', '$location', '$rootScope', '$controller', 'auiUpload', 'auiDialog', 'OpenUp', 'UserInfo', 'OpenOther', 'regionService', 'modBussService', 'UserInfoPreload', 'modUserInfoService', 'bankSelectService', 'openAddContactor', 'formValidateService', '$filter', 'auiAgreementHelper', 'tenantsService',
        function ($q, $scope, $state, $location, $rootScope, $controller, auiUpload, auiDialog, OpenUp, UserInfo, OpenOther, regionService, modBussService, UserInfoPreload, modUserInfoService, bankSelectService, openAddContactor, formValidateService, $filter, auiAgreementHelper, tenantsService) {
            $controller('ModBussnessInfo', {$scope: $scope});//导入

            var Model = $scope.Model;
            Model.operationInfoFlag = false
            Model.bankAccountPicWH = "";
            Model.submbIsGray = false;
            Model.acctNameAttachmentCN = "";
            Model.userTypePer = 1;
            Model.userTypeCorp = 2;
            var urlTempAttachmentCN;
            //商户简称
            Model.mercShortName = '';
            Model.isShowSrmTip = false; //后台管理员通知CP消息
            Model.SrmMsgTip = "";
            Model.newBank = {};
            Model.branchs = [];
            //联系人信息
            Model.contactorInfo = {};
            Model.userID = '';

            Model.isShowUpdateBranch = false;
            Model.userInfo = UserInfoPreload;
            var userTypePer = 1;
            Model.contactWithCustomService = window.sysUrlCfg.documentHref.contactWithCustomService;
            Model.contactWithCustomServiceDescribeCN = ['如您选择不到所需的开户银行，请提供开户银行、开户行支行和开户行号，通过<a class="text-link" target="_blank" href="', window.sysUrlCfg.documentHref.contactWithCustomService, '">工单系统</a>反馈问题。'].join('');
            Model.accountTips = '该开户行帐号为贵公司的收款帐号，请确保银行账户名称与“开户名”保持一致。';
            Model.mercShortNameTips = '我们已升级更优质的商户资金结算服务，根据最新商户资金结算服务规定，需要提供您的商户简称信息。';
            Model.isShowControllerList = false;
            Model.today = new Date();
            Model.timeline = '长期有效建议选择2099-12-31';
            Model.controllerAmount = 0;
            var oldBankInfoCN = {};
            var oldUserInfo = {};

            var lastSelBank = '';
            var lastSelBranch = '';

            //税务信息
            Model.taxInfo = {};
            var urlTemp;

            var oldTaxInfo = {};

            var taxType = {0: '个人', 1: '企业'};

            // 计录页面修改项的计数
            var oldContactor = {};
            var contactorType = ['market', 'finance', 'legal', 'coorperation'];
            //scope里面的函数定义
            $scope.openAddContactorPage = openAddContactorPage;
            $scope.changeTaxReceiptType = changeTaxReceiptType;
            $scope.taxNumKeyup = taxNumKeyup;
            $scope.registerAddressKeyup = registerAddressKeyup;
            $scope.changeTaxProvince = changeTaxProvince;
            $scope.uploadBankAccountPic = uploadBankAccountPic;
            $scope.bankAccountKeyup = changeBankInfoCN;
            $scope.accountNameKeyup = changeBankInfoCN;
            $scope.changeBankCity = changeBankCity;
            $scope.changeBankProvince = changeBankProvince;
            $scope.changeBank = changeBank;
            $scope.changeCountry = changeBankInfoCN;
            $scope.cancel = cancel;
            $scope.branchSelected = branchSelected;

            $scope.backSelected = backSelected;

            //更名
            $scope.doPreStep = doPreStep;
            $scope.doSubmitNameChange = doSummit;
            $scope.uploadAcctNameAttachment = uploadAcctNameAttachment;
            $scope.merchantServiceSelect = merchantServiceSelect;
            $scope.showAgreement = showAgreement;
            $scope.showSearchDlgCN = showSearchDlg(true);

            initBussiness();
            OpenUp.getMerchantTaxInfo({
                req: {}
            }).then(function (taxInfo) {
                Model.otherTaxsIncluded = taxInfo.merchantTaxInfo.otherTaxsIncluded ? taxInfo.merchantTaxInfo.otherTaxsIncluded : 0;
                Model.defaultOtherTaxsIncluded = taxInfo.merchantTaxInfo.otherTaxsIncluded ? taxInfo.merchantTaxInfo.otherTaxsIncluded : 0;
                taxInfo.merchantTaxInfo.deliveryCountryTaxItems[0].taxItems.forEach(function (item) {
                    if (item.taxClassCode == 'NA') {
                        Model.newTaxItem[Model.newTaxItem.length - 1].taxNum = item.taxNumber;
                        Model.TaxItem[Model.TaxItem.length - 1].termsIsSelected = true;
                        Model.TaxItem[Model.TaxItem.length - 1].disabled = false;
                    } else {
                        Model.newTaxItem[item.taxClassCode[item.taxClassCode.length - 1] - 1].taxNum = item.taxNumber;
                        Model.TaxItem[item.taxClassCode[item.taxClassCode.length - 1] - 1].termsIsSelected = true;
                        Model.TaxItem[item.taxClassCode[item.taxClassCode.length - 1] - 1].disabled = false
                    }
                });
            })

            //选择某一开户银行触发调用  这个里面太多调用本地的方法吧  暂时不移植
            function backSelected(obj) {
                //新增初始化时Model.bankInfo.bank为空，需要初始化.
                !Model.bankInfoCN.bank && (Model.bankInfoCN.bank = {key: '', value: ''});
                if (obj) {
                    //变更时删除加入的手工录入银行
                    if (Model.newBank.key && obj.originalObject.key != Model.newBank.key) {
                        var test = Model.bankCNs.pop();
                        Model.newBank = {};
                    }
                    //带title:选中的
                    if (obj.title) {
                        Model.bankInfoCN.bank.value = obj.title;
                        Model.bankInfoCN.bank.key = obj.title;
                        if (obj.title != lastSelBank) {
                            lastSelBank = obj.title;
                            changeBank(Model.bankInfoCN.bank.value);
                            Model.isShowUpdateBranch = false;
                        }
                    } else if (obj.originalObject.key) {
                        Model.bankInfoCN.bank.key = obj.originalObject.key;
                        Model.bankInfoCN.bank.value = obj.originalObject.key;
                        if (obj.originalObject.key != lastSelBank) {
                            lastSelBank = obj.originalObject.key;
                            changeBank(Model.bankInfoCN.bank.value);
                            Model.isShowUpdateBranch = false;
                        }
                    }
                } else {
                    Model.bankInfoCN.bank = {
                        key: '',
                        value: ''
                    };
                }

            }


            //初始化
            function initBussiness() {
                if ($rootScope.changeNameParams) {
                    Model.changeNameParams = angular.copy($rootScope.changeNameParams);
                    modBussService.getIsSignAgreement(Model).then(function () {
                        regionService.setProvince(function (data) {
                            Model.provinces = data;
                            contactorInit().then(function () {
                                getBussinessInfo();
                                bankInit();
                            });
                        });
                    });

                } else {
                    cancel();
                }

            }

            function merchantServiceSelect(selected) {
                Model[selected] = !Model[selected];
            }


            function showAgreement() {
                // 根据最新的协议版本，查询协议平台，弹框提示签署
                window.open(AUI.BaseJSUtil.getSafeUrl(Model.notSignAgreeUrl));
            }

            //获取银行信息
            function getBussinessInfo() {
                modBussService.getBussinesInfo('00011000001001', function (data) {
                    Model.developerInfoOld = data.developerInfo;
                    var strController = [];
                    //将数组里的对象转化成字符串存放在controllerListOld里用于比较用户是否改变了实控人信息
                    if (data.controllerList && data.controllerList.length > 0) {
                        data.controllerList.forEach(function (item) {
                            item.ctfEffectiveDate = $filter('auiDateFormat')(item.ctfEffectiveDate, '+0800');
                            item.ctfExpireDate = $filter('auiDateFormat')(item.ctfExpireDate, '+0800');
                            strController.push(JSON.stringify(item));
                        })

                    }
                    //判断商户简称如何展示
                    if (data) {
                        if (data.bankInfoCN && data.bankInfoCN.mercShortName) {
                            $scope.Model.defalutMercShortName = data.bankInfoCN.mercShortName;
                            $scope.Model.mercShortName = data.bankInfoCN.mercShortName;
                        } else if (data.bankInfoCN && data.bankInfoCN.bankAcctName && data.bankInfoCN.bankAcctName.length < 21) {
                            $scope.Model.mercShortName = data.bankInfoCN.bankAcctName;
                        } else if (data.developerInfo && data.developerInfo.realName && data.developerInfo.realName.length < 21) {
                            $scope.Model.mercShortName = data.developerInfo.realName;
                        }
                    }
                    Model.controllerList = data.controllerList;
                    Model.controllerListOld = strController;
                    Model.userTaxInfoOld = data.userTaxInfo;
                    if (data.bankInfoCN) {
                        Model.bankInfoCN = angular.fromJson(data.bankInfoCN);
                        Model.bankInfoCN.bankAcctName = Model.changeNameParams.developerInfo.realName;
                    }
                    if (data.bankInfoEN) {
                        Model.bankInfoEN = angular.fromJson(data.bankInfoEN);
                        Model.bankInfoEN.bankAcctName = Model.changeNameParams.developerInfo.realName;
                    }
                    renderBankData();
                    oldUserInfo = angular.copy(data.developerInfo);
                    Model.incorDeveloper = data.indivDeveloper || data.corpDeveloper;
                    renderTaxData(data.developerInfo, data.userTaxInfo);
                    //tax info要从这里进
                    taxInit();
                    if (data) {
                        Model.userID = data.userID;
                        if (data.contactInfo) {
                            getOldContactorInfo(data.contactInfo);
                            if (Model.changeNameParams && Model.changeNameParams.developerMerchantInfo && Model.changeNameParams.developerMerchantInfo.contactList) {
                                Model.merchantContacts.forEach(function (u) {
                                    if (Model.changeNameParams.developerMerchantInfo.contactList.market == u.key) {
                                        Model.contactorInfo[contactorType[0]] = {
                                            key: u.key,
                                            value: u.value
                                        };
                                    }
                                    if (Model.changeNameParams.developerMerchantInfo.contactList.finance == u.key) {
                                        Model.contactorInfo[contactorType[1]] = {
                                            key: u.key,
                                            value: u.value
                                        };
                                    }
                                    if (Model.changeNameParams.developerMerchantInfo.contactList.legal == u.key) {
                                        Model.contactorInfo[contactorType[2]] = {
                                            key: u.key,
                                            value: u.value
                                        };
                                    }
                                    if (Model.changeNameParams.developerMerchantInfo.contactList.coorperation == u.key) {
                                        Model.contactorInfo[contactorType[3]] = {
                                            key: u.key,
                                            value: u.value
                                        };
                                    }
                                });
                            } else {
                                data.contactInfo.forEach(function (v) {
                                    for (var i = 0; i < contactorType.length; i++) {
                                        if (v.role == contactorType[i] && v.contactMeta) {
                                            Model.contactorInfo[contactorType[i]] = {
                                                key: v.contactMeta.contactID,
                                                value: v.contactMeta.familyName + v.contactMeta.givenName
                                            };
                                            break;
                                        }


                                    }
                                });
                            }
                        }
                    }
                });
            }

            function getOldContactorInfo(contactInfo) {
                if (contactInfo) {
                    contactInfo.forEach(function (v) {
                        if (v.contactMeta) {
                            for (var i = 0; i < contactorType.length; i++) {
                                if (v.role == contactorType[i]) {
                                    oldContactor[contactorType[i]] = {
                                        key: v.contactMeta.contactID,
                                        value: v.contactMeta.familyName + v.contactMeta.givenName
                                    };
                                    break;
                                }
                            }
                        }
                    });
                }
            }


            //初始化国家、币种
            function bankInit() {
                bankSelectService.getBanks(0, function (res) {
                    if (res) {
                        res.forEach(function (bank) {
                            Model.bankCNs.push(bank);
                        });
                    }
                });
            }


            //校验银行数据
            function renderBankData() {
                if (Model.changeNameParams && Model.changeNameParams.developerMerchantInfo && Model.changeNameParams.developerMerchantInfo.bankInfoCN) {
                    renderPicDataCN(Model.changeNameParams.developerMerchantInfo.bankInfoCN);
                    operationInfo()
                } else {
                    if (Model.bankInfoCN) {
                        renderPicDataCN(Model.bankInfoCN);
                        operationInfo()
                    }
                }
            }


            //显示银行信息
            function renderPicDataCN(bankInfo) {
                // mod by at 1.7.1 for 银行信息配置优化   begin
                //如果存在银行信息
                if (bankInfo && bankInfo.bankName) {
                    Model.bankInfoCN.bankAccount = bankInfo.bankAccount;
                    Model.bankInfoCN.accountName = bankInfo.bankAcctName;
                    //总行 省 市 支行 开户行号
                    Model.bankInfoCN.bank = {
                        key: bankInfo.bankName,
                        value: bankInfo.bankName
                    };
                    lastSelBank = Model.bankInfoCN.bank.key;
                    Model.bankInfoCN.province = {
                        key: bankInfo.hProvince,
                        value: bankInfo.hProvince
                    };
                    Model.bankInfoCN.city = {
                        key: bankInfo.hCity,
                        value: bankInfo.hCity
                    };
                    Model.bankInfoCN.branch = {
                        key: bankInfo.hAddr,
                        value: bankInfo.hAddr
                    };
                    lastSelBranch = Model.bankInfoCN.branch.key;
                    $scope.initBranchValue = Model.bankInfoCN.branch.key ? Model.bankInfoCN.branch.key : '';
                    //国家 币种 税票类型信息
                    Model.bankInfoCN.country = {key: "CN", value: '中国'};
                    Model.bankInfoCN.currency = bankInfo.currency;
                    Model.bankInfoCN.swiftCode = bankInfo.swiftCode;
                    Model.bankInfoCN.branchNumber = bankInfo.branchNumber;
                    getBankBranchRegions(Model.bankInfoCN.bank.key, Model.bankInfoCN.province.key, Model.bankInfoCN.city.key, Model.bankInfoCN.branch.key, true);

                }

                if (bankInfo && bankInfo.bankAttachment) {
                    Model.bankInfoCN.bankAccountPic = bankInfo.bankAttachment;
                    AUI.HTMLUtil.drawImage(180, 120, bankInfo.bankAttachment, function (wh) {
                        $scope.$apply(function () {
                            Model.bankAccountPicWH = wh;
                        });
                    });
                }
                if (Model.bankInfoCN && Model.bankInfoCN.acctNameAttachment) {
                    Model.acctNameAttachmentCN = Model.bankInfoCN.acctNameAttachment;
                    AUI.HTMLUtil.drawImage(180, 120, Model.acctNameAttachmentCN, function (wh) {
                        $scope.$apply(function () {
                            Model.acctNameAttachmentENWH = wh;
                        });
                    });
                }

                oldBankInfoCN = angular.copy(Model.bankInfoCN);
                if (Model.bankInfoCN && Model.bankInfoCN.bankAccount) {
                    Model.bankInfoCN.bankAccount = formValidateService.hiddenInfo(Model.bankInfoCN.bankAccount, 0, 4);
                    Model.bankInfoCN.bankAccountFuzzy = angular.copy(Model.bankInfoCN.bankAccount);
                }
                // mod by at 1.7.1 for 银行信息配置优化   end
            }

            Model.bankAccountCnKeyup = function () {
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldBankInfoCN.bankAccount) {
                    if (oldBankInfoCN.bankAccount != Model.bankInfoCN.bankAccount && Model.bankInfoCN.bankAccountFuzzy != Model.bankInfoCN.bankAccount) {
                        if (!formValidateService.testBankAccout(Model.bankInfoCN.bankAccount)) {
                            $scope.bankInfoForm.bankAccountCN.$dirty = true;
                            $scope.bankInfoForm.bankAccountCN.$error.pattern = true;
                            return;
                        }
                    }
                } else {
                    if (!formValidateService.testBankAccout(Model.bankInfoCN.bankAccount)) {
                        $scope.bankInfoForm.bankAccountCN.$dirty = true;
                        $scope.bankInfoForm.bankAccountCN.$error.pattern = true;
                        return;
                    }
                }

                $scope.bankInfoForm.bankAccountCN.$dirty = false;
                $scope.bankInfoForm.bankAccountCN.$error.pattern = false;
            }

            //改变银行
            function changeBank(bank) {
                getBankBranchRegions(bank);
                // 如果新值跟原值不一样，则亮化提交按钮
                changeBankInfoCN();
                if (Model.bankInfoCN.bank && (oldBankInfoCN.bank && oldBankInfoCN.bank.value != Model.bankInfoCN.bank.value || !oldBankInfoCN.bank && Model.bankInfoCN.bank.value)) {
                    Model.bankInfoCN.province = {key: '', value: '省份/直辖市'};
                    Model.bankInfoCN.city = {key: '', value: '市/区'};
                    Model.bankInfoCN.branch = {key: '', value: '请选择支行'};
                    Model.bankInfoCN.branchNumber = '';
                    Model.branchs = [];
                    Model.bankCities = [];

                    if (!Model.isShowUpdateBranch) {
                        // 改变银行省后，需要将之前的银行信息清除
                        document.querySelector('#branchAutoCN_value').value = '';
                        $scope.$broadcast('huaweicomplete-alt:clearInput', 'branchAutoCN');
                    }
                    $scope.bankInfoForm.bankCNProvince.$setPristine();
                    $scope.bankInfoForm.bankCNCity.$setPristine();
                    $scope.bankInfoForm.bankCNBranch.$setPristine();
                }
            }

            //改变银行里面的省
            function changeBankProvince(province) {
                getCities(Model.bankInfoCN.bank.key, province);
                changeBankInfoCN();
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeBankNum
                if (Model.bankInfoCN.province && (oldBankInfoCN.province && oldBankInfoCN.province.value != Model.bankInfoCN.province.value ||
                    !oldBankInfoCN.province && Model.bankInfoCN.province.value)) {
                    Model.bankInfoCN.city = {key: '', value: '市/区'};
                    Model.bankInfoCN.branch = {key: '', value: '请选择支行'};
                    Model.bankInfoCN.branchNumber = '';
                }
            }

            //改变银行的城市
            function changeBankCity(city) {
                getBankBranchs(Model.bankInfoCN.bank.key, Model.bankInfoCN.province.value, city);
                // 如果新值跟原值不一样，则亮化提交按钮
                changeBankInfoCN();
                if (Model.bankInfoCN.city && (oldBankInfoCN.city && oldBankInfoCN.city.value != Model.bankInfoCN.city.value ||
                    !oldBankInfoCN.city && Model.bankInfoCN.city.value)) {
                    Model.bankInfoCN.branch = {key: '', value: '请选择支行'};
                    Model.bankInfoCN.branchNumber = '';
                    if (!Model.isShowUpdateBranch) {
                        // 改变银行省后，需要将之前的银行信息清除
                        document.querySelector('#branchAutoCN_value').value = '';
                        $scope.$broadcast('huaweicomplete-alt:clearInput', 'branchAutoCN');
                    }
                }
            }

            function getBankBranchRegions(bank, province, city, branch, fl) {
                bankSelectService.getBankBranchRegions(bank, function (data) {
                    Model.bankProvinces = data;
                    if (province) {
                        getCities(bank, province, city, branch, fl);
                    }
                });
            }

            function getCities(bank, province, city, branch, fl) {
                // 调用opendeveloper接口从idata中获取省下面的市的信息。
                bankSelectService.getBankBranchRegionsCity(bank, province, function (cityData) {
                    Model.bankCities = cityData;
                    if (city) {
                        getBankBranchs(bank, province, city, branch, fl);
                    }
                });
            }

            function getBankBranchs(bank, province, city, branch, fl) {
                bankSelectService.getBankBranchs(bank, province, city, function (data) {
                    bankSelectService.handleAfterGetBankBranchs(Model, data, branch, fl)
                });
            }

            //上传法人视频
            Model.uploadVideo = function (files, options) {
                if (Model.isAudting) return;
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    Model.bankInfoCN.legalManVideoUrl = fileUrl;
                    changeBankInfoCN();
                })
            }

            //上传资质图片
            function uploadAcctNameAttachment(files, options, type) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    var changed = fileUrl && fileUrl != Model[type];
                    if (changed) {
                        changeBankInfoCN();
                        urlTempAttachmentCN = fileUrl;
                        Model[type] = fileUrl;
                        if (Model[type].indexOf('.pdf') == -1) {
                            AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                                $scope.$apply(function () {
                                    Model.acctNameAttachmentENWH = wh;
                                });
                            });
                        } else {
                            Model.acctNameAttachmentENWH = {width: "180px", height: "120px", left: "0px", top: "0px"};
                        }
                    }
                });
            }


            //上传银行的图片
            function uploadBankAccountPic(files, options) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    if (fileUrl && fileUrl != Model.bankInfoCN.bankAccountPic) {
                        changeBankInfoCN();
                        urlTemp = fileUrl;
                        Model.bankInfoCN.bankAccountPic = fileUrl;
                        if (Model.bankInfoCN.bankAccountPic.indexOf('.pdf') == -1) {
                            AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                                $scope.$apply(function () {
                                    Model.bankAccountPicWH = wh;
                                });
                            });
                        } else {
                            Model.bankAccountPicWH = {width: "180px", height: "120px", left: "0px", top: "0px"};
                        }
                    }
                });
            }

            //税务初始化
            function taxInit() {
                //初始化税票类型
                Model.taxReceiptTypes = getTaxReceiptTypes();
            }

            //获取税务类型
            function getTaxReceiptTypes() {
                var taxReceiptTypes = [];
                if (Model.taxInfo.taxType == 1 || (!Model.taxInfo.taxType && Model.userType == Model.userTypeCorp)) {
                    for (var i in systemParaConf.taxReceiptTypeCorp) {
                        taxReceiptTypes.push({key: i, value: systemParaConf.taxReceiptTypeCorp[i]});
                    }
                } else {
                    for (var k in systemParaConf.taxReceiptTypePer) {
                        taxReceiptTypes.push({key: k, value: systemParaConf.taxReceiptTypePer[k]});
                    }
                }
                return taxReceiptTypes;
            }

            //设置税务信息，从userTaxInfo中获取
            function renderTaxData(developerInfo, userTaxInfo) {
                // mod by at 1.7.1 for 银行信息配置优化   begin
                Model.taxInfo.registerAddress = userTaxInfo.registerAddress || Model.incorDeveloper.corpAddress || Model.incorDeveloper.indivAddress;
                Model.taxInfo.realName = developerInfo.realName;
                /**
                 *  如果已经有省市信息，要根据填写的省市（包括城市）和实名认证的信息作对比
                 *  1.如果二者相同，则默认选中实名认证中的省市和城市
                 *  2.如果二者不一样，则将Model.taxInfo.province/taxCity设置成空，有用户手动选择
                 */
                if (Model.userTaxInfoOld) {
                    // 税务信息中的省市信息和实名认证的省市信息不一样，则将Model.taxInfo.province设成空，有用户自己选择
                    if (!Model.isAudting && (Model.userTaxInfoOld.taxProvinceName != Model.incorDeveloper.provinceName)) {
                        regionService.getProvinceByName(Model.incorDeveloper.provinceName, function (res) {
                            if (!res) {
                                auiDialog.warn('省份不准确', '您注册的省份不准确，请重新提交。', function () {
                                    $rootScope.toSettingUserInfo();
                                });

                            }
                            // 供税务下拉的省市（包括城市）列表（现在要求与实名认证的省市一致）
                            Model.taxInfoForSelect.province = [{
                                key: Model.incorDeveloper.provinceName,
                                value: res
                            }];

                        });
                        Model.taxInfo.province = {};
                    } else {
                        Model.taxInfo.province = {
                            key: userTaxInfo.taxProvinceName,
                            value: userTaxInfo.taxProvince
                        };
                    }
                    // 税务信息中的城市信息和实名认证的城市信息不一样，则将Model.taxInfo.city设成空，有用户自己选择
                    if (!Model.isAudting && (Model.userTaxInfoOld.taxCityName != Model.incorDeveloper.cityName)) {
                        regionService.getCityByName(Model.incorDeveloper.cityName, function (res) {
                            if (!res) {
                                auiDialog.warn('城市不准确', '您注册的城市不准确，请重新提交。 ', function () {
                                    $rootScope.toSettingUserInfo();
                                });
                                return;
                            }
                            Model.taxInfoForSelect.city = [{
                                key: Model.incorDeveloper.cityName,
                                value: res
                            }];

                        });
                        Model.taxInfo.city = {};
                    } else {
                        Model.taxInfo.city = {
                            key: userTaxInfo.taxCityName,
                            value: userTaxInfo.taxCity
                        };
                    }

                    Model.taxInfo.taxReceiptType = userTaxInfo.taxReceiptType ? {
                        key: userTaxInfo.taxReceiptType,
                        value: systemParaConf.taxReceiptType[userTaxInfo.taxReceiptType]
                    } : {key: '', value: ''};
                    Model.taxInfo.taxType = developerInfo.userType - 1;
                    Model.taxInfo.taxNum = userTaxInfo.taxNum;
                    Model.taxInfo.typeDesc = taxType[Model.taxInfo.taxType];
                } else {
                    Model.taxInfo.taxType = developerInfo.userType - 1;
                    Model.taxInfo.typeDesc = taxType[Model.taxInfo.taxType];
                }

                oldTaxInfo = angular.copy(Model.taxInfo);
            }


            //改变税务的省
            function changeTaxProvince(province) {
                regionService.setCity(province, function (data) {
                    Model.taxCities = data;
                    if (Model.taxInfo.province && (oldTaxInfo.province && oldTaxInfo.province.value != Model.taxInfo.province.value || !oldTaxInfo.province && Model.taxInfo.province.value)) {
                        Model.taxInfo.city = Model.taxCities[0];
                    }
                });

            }

            //改变税务注册地址
            function registerAddressKeyup() {
                Model.isInTaxReceiptTypes = false;
            }

            //改变税号
            function taxNumKeyup() {
                Model.isInTaxReceiptTypes = false;
            }

            //改变税务类型
            function changeTaxReceiptType() {
                Model.isInTaxReceiptTypes = false;
            }


            //初始化联系人
            function contactorInit() {
                var defer = $q.defer();
                //初始化联系方式
                OpenUp.getContactMetaList({req: {}}).then(
                    function (data) {
                        if (data && data.contactList) {
                            tenantsService.setPageContactInfo(Model, data.contactList);
                            defer.resolve();
                        } else {
                            defer.resolve();
                        }
                    }
                );
                return defer.promise;
            }


            //增加联系人页面
            function openAddContactorPage() {
                openAddContactor.openPage({
                    userID: Model.userID,
                    close: function () {
                        contactorInit();
                    }
                });
            }

            function validTaxType() {
                var isInTaxReceiptTypes = false;
                Model.taxReceiptTypes.forEach(function (type) {
                    if (Model.taxInfo.taxReceiptType.key == type.key) {
                        isInTaxReceiptTypes = true;
                    }
                });
                return isInTaxReceiptTypes;
            }


            //上一步
            function doPreStep() {
                $rootScope.changeNameParams = angular.copy(Model.changeNameParams);
                if ($rootScope.changeNameParams.developerMerchantInfo) {
                    delete $rootScope.changeNameParams.developerMerchantInfo;
                }
                if (UserInfoPreload.userType == userTypePer) {
                    $state.go("nameChangePer.userInfoPer");
                } else {
                    $state.go("nameChangeCorp.userInfoCorp");
                }
            }

            //取消
            function cancel() {
                delete $rootScope.changeNameParams;
                $rootScope.modFlag = false;
                delete $rootScope.isInNameChange;
                $rootScope.toSettingUserInfo();
            }

            //提交
            function doSummit(isValid) {
                var defer = $q.defer();
                //判断开发者有没有勾选花瓣协议和隐私协议，没签署要做限制
                if (!Model.petalsTremServicIsSelected && !Model.agreements.petalsTremServiceAgree.isSignedAgree && Model.agreements.petalsServiceAgree.isSignedAgree) {
                    Model.showTremAgreeWarn = true;
                    Model.showServiceAgreeWarn = false;
                    return;
                } else if (!Model.petalsTremServicIsSelected && !Model.agreements.petalsServiceAgree.isSignedAgree && Model.agreements.petalsTremServiceAgree.isSignedAgree) {
                    Model.showServiceAgreeWarn = true;
                    Model.showTremAgreeWarn = false;
                    return;
                } else if (!Model.petalsTremServicIsSelected && !Model.agreements.petalsServiceAgree.isSignedAgree && !Model.agreements.petalsTremServiceAgree.isSignedAgree) {
                    Model.showServiceAgreeWarn = true;
                    Model.showTremAgreeWarn = true;
                    return;
                }
                if (Model.operationInfoFlag) {
                    Model.checkSceneFlag = (Model.chooseSceneList.length === 0)
                    if (Model.checkSceneFlag) {
                        return
                    }
                }
                Model.isInTaxReceiptTypes = false;
                if ($scope.bankInfoForm.ctfEffectiveDate) $scope.bankInfoForm.ctfEffectiveDate.$dirty = true;
                if ($scope.bankInfoForm.ctfFrontPicFile) $scope.bankInfoForm.ctfFrontPicFile.$dirty = true;
                if ($scope.bankInfoForm.ctfBackPicFile) $scope.bankInfoForm.ctfBackPicFile.$dirty = true;
                if ($scope.bankInfoForm.ctfCode) $scope.bankInfoForm.ctfCode.$dirty = true;
                if ($scope.bankInfoForm['controllerName0']) $scope.bankInfoForm['controllerName0'].$dirty = true;
                if ($scope.bankInfoForm['controllerName1']) $scope.bankInfoForm['controllerName1'].$dirty = true;
                if ($scope.bankInfoForm['controllerName2']) $scope.bankInfoForm['controllerName2'].$dirty = true;
                if ($scope.bankInfoForm['controllerName3']) $scope.bankInfoForm['controllerName3'].$dirty = true;
                if ($scope.bankInfoForm['controllerAddress0']) $scope.bankInfoForm['controllerAddress0'].$dirty = true;
                if ($scope.bankInfoForm['controllerAddress1']) $scope.bankInfoForm['controllerAddress1'].$dirty = true;
                if ($scope.bankInfoForm['controllerAddress2']) $scope.bankInfoForm['controllerAddress2'].$dirty = true;
                if ($scope.bankInfoForm['controllerAddress3']) $scope.bankInfoForm['controllerAddress3'].$dirty = true;
                if ($scope.bankInfoForm['taxItem']) $scope.bankInfoForm['taxItem'].$dirty = true;
                if ($scope.bankInfoForm['otherTaxsIncluded']) $scope.bankInfoForm['otherTaxsIncluded'].$dirty = true;
                Model.isNewController = false;
                if (!isValid) {
                    defer.reject();
                    formValidateService.validateForm($scope.bankInfoForm);
                } else if (!validTaxType()) {
                    defer.reject();
                    Model.isInTaxReceiptTypes = true;
                    angular.element("[name='taxReceiptType']").focus();
                } else if ($scope.bankInfoForm.bankAccountCN.$error.pattern) {//银行账户的问题
                    defer.reject();
                    angular.element("[name='bankAccountCN']").focus();
                } else {
                    var tmp = angular.copy(oldBankInfoCN);
                    tmp.accountName = oldUserInfo.realName;
                    //校验都过的情况下弹出银行卡二次确认
                    bankSelectService.showConfirmDlg({
                        bankCN: Model.bankInfoCN,
                        oldBankCN: tmp,
                        bankSelectedCN: true,
                        mercShortName: Model.mercShortName
                    }).then(function () {
                        var contact = {};
                        var contactList;
                        if (Model.contactorInfo && Model.contactorInfo.market) {
                            contact.market = Model.contactorInfo.market.key
                        }
                        if (Model.contactorInfo.finance && Model.contactorInfo.finance) {
                            contact.finance = Model.contactorInfo.finance.key
                        }
                        if (Model.contactorInfo && Model.contactorInfo.legal) {
                            contact.legal = Model.contactorInfo.legal.key
                        }
                        if (Model.contactorInfo && Model.contactorInfo.coorperation) {
                            contact.coorperation = Model.contactorInfo.coorperation.key
                        }
                        if (Model.contactorInfo && (Model.contactorInfo.market || Model.contactorInfo.finance || Model.contactorInfo.legal || Model.contactorInfo.coorperation)) {
                            contactList = contact;
                        }
                        //在加拿大的税务信息
                        var CountryTaxItems = [];
                        var canadaTaxNumber = [];
                        Model.TaxItem.forEach(function (item, i) {
                            if (item.termsIsSelected && item.taxName != 'NA') {
                                canadaTaxNumber.push({
                                    taxClassCode: 'CA00' + (i + 1),
                                    taxNumber: Model.newTaxItem[i].taxNum
                                })
                            } else if (item.termsIsSelected && item.taxName == 'NA') {
                                canadaTaxNumber.push({
                                    taxClassCode: 'NA',
                                    taxNumber: ''
                                })
                            }
                        })
                        if (Model.otherTaxsIncluded == 2) {
                            CountryTaxItems.push({
                                taxCountry: 'CA',
                                taxItems: canadaTaxNumber
                            })
                        } else {
                            CountryTaxItems = null;
                        }
                        var userTaxInfo = {
                            taxProvinceName: Model.taxInfo.province.key,
                            taxProvince: Model.taxInfo.province.value,
                            taxNum: Model.taxInfo.taxNum,
                            taxCityName: Model.taxInfo.city.key,
                            taxCity: Model.taxInfo.city.value,
                            taxType: Model.taxInfo.taxType + '',
                            registerAddress: Model.taxInfo.registerAddress,
                            taxReceiptType: Model.taxInfo.taxReceiptType.key,
                            taxCountry: 'CN',
                            taxOrgCategory: 1,
                        };
                        if (Model.otherTaxsIncluded) {
                            userTaxInfo.otherTaxsIncluded = Model.otherTaxsIncluded;
                            userTaxInfo.deliveryCountryTaxItems = CountryTaxItems;
                        }

                        // 拼装请求参数
                        var jsonStr = {
                            developerMerchantInfo: {
                                contactList: contactList,
                                developerBanks: [{
                                    bankName: Model.bankInfoCN.bank.value,
                                    bankAcctName: Model.bankInfoCN.accountName,
                                    bankAccount: (Model.bankInfoCN.bankAccount == Model.bankInfoCN.bankAccountFuzzy) ? oldBankInfoCN.bankAccount : Model.bankInfoCN.bankAccount,
                                    hProvince: Model.bankInfoCN.province.value,
                                    hCity: Model.bankInfoCN.city.value,
                                    hAddr: Model.bankInfoCN.branch.value,
                                    country: Model.bankInfoCN.country.key,
                                    currency: 'CNY',
                                    bankType: 0,
                                    branchNumber: String(Model.bankInfoCN.branchNumber),
                                    swiftCode: Model.bankInfoCN.swiftCode || '',
                                    bankAttachment: '',
                                    acctNameAttachment: Model.acctNameAttachmentCN,
                                    mercShortName: Model.mercShortName
                                }
                                ]
                            },
                            userTaxInfo: userTaxInfo
                        };

                        if (Model.bankInfoCN.legalManVideoUrl) {
                            jsonStr.developerMerchantInfo.developerBanks[0].legalManVideoUrl = Model.bankInfoCN.legalManVideoUrl;
                        }
                        var jsonStr1 = modBussService.beforeSubmitBankInfo(Model, $scope, oldBankInfoCN);
                        var changeNameParams = Model.changeNameParams;
                        if (jsonStr1 && jsonStr1.controllerInfo) changeNameParams.controllerInfo = jsonStr1.controllerInfo;
                        if (jsonStr1 && jsonStr1.merchantBusinessInfo && Model.operationInfoFlag) changeNameParams.merchantBusinessInfo = jsonStr1.merchantBusinessInfo;
                        changeNameParams.developerMerchantInfo = jsonStr.developerMerchantInfo;
                        changeNameParams.merchantTaxInfo = jsonStr.userTaxInfo;
                        modBussService.signSingleAgreement(Model, 'merchantServiceAgree', Model.merchantServiceIsSelected).then(function (data) {
                            modBussService.signSingleAgreement(Model, 'petalsTremServiceAgree', true).then(function () {
                                modBussService.signSingleAgreement(Model, 'petalsServiceAgree', true).then(function () {
                                    modUserInfoService.changeNameFun(angular.copy(changeNameParams)).then(function (data) {
                                        if (data) {
                                            $rootScope.modFlag = false;
                                            delete $rootScope.changeNameParams;
                                            delete $rootScope.isInNameChange;
                                            $scope.$emit("stateChangedEvent", true);
                                            if (UserInfoPreload.userType == userTypePer) {
                                                defer.resolve();
                                                $state.go("nameChangePer.submitSuccess");
                                            } else {
                                                defer.resolve();
                                                $state.go("nameChangeCorp.submitSuccess");
                                            }
                                        } else {
                                            defer.reject();
                                        }
                                    }).catch(function () {
                                        defer.reject();
                                    });
                                });
                            });
                        }).catch(function () {
                            defer.reject();
                        })
                    }, function () {
                        defer.reject();
                    });
                }
                return defer.promise;
            }


            // autocomplete 回调方法 不继承
            function branchSelected(obj) {
                if (obj) {
                    Model.bankInfoCN.branch.value = obj.originalObject.value;
                    Model.bankInfoCN.branch.key = obj.originalObject.key;
                    // 现在不用再调用openother获取支行号。
                    Model.bankInfoCN.branchNumber = obj.originalObject.branchNumber;
                    if (obj.title != lastSelBranch) {
                        Model.isShowUpdateBranch = false;
                        lastSelBranch = obj.title;
                    }
                } else {
                    Model.bankInfoCN.branch.key = '';
                    Model.bankInfoCN.branch.value = '';
                }
            }


            function showSearchDlg(isCN) {
                var suffix = isCN ? "CN" : "EN";
                return function () {
                    bankSelectService.showSearchDlg({
                        callBack: function (branch) {
                            function setBank(branch) {
                                Model['bankInfo' + suffix].hProvince = branch.province;
                                Model['bankInfo' + suffix].hCity = branch.city;
                                Model['bankInfo' + suffix].hAddr = branch.branchName;
                                Model['bankInfo' + suffix].bank = {key: branch.bankName, value: branch.bankName};
                                $scope.$broadcast('huaweicomplete-alt:changeInput', 'backAuto' + suffix, Model['bankInfo' + suffix].bank); //设置控件值
                                Model['bankInfo' + suffix].province = {key: branch.province, value: branch.province};
                                Model['bankInfo' + suffix].city = {key: branch.city, value: branch.city};
                                Model['bankInfo' + suffix].branch = {key: branch.branchName, value: branch.branchName};
                                $scope.$broadcast('huaweicomplete-alt:changeInput', 'branchAuto' + suffix, Model['bankInfo' + suffix].branch); //设置控件值
                                Model['bankInfo' + suffix].branchNumber = branch.branchNumber;
                                Model['bankInfo' + suffix].branch.branchNumber = branch.branchNumber
                                Model['bankInfo' + suffix].swiftCode = branch.swiftCode;
                                !isCN && (Model['bankInfo' + suffix].branch.swiftCode = branch.swiftCode);//这个不确定干什么的，先保留
                            }

                            setBank(branch);
                        },
                        initBranchNumber: isCN ? Model['bankInfo' + suffix].branchNumber : null,
                        initswiftCode: !isCN ? Model['bankInfo' + suffix].swiftCode : null,
                        isCN: isCN
                    });
                }
            }

            function changeBankInfoCN() {
                var changed = false;
                var old = oldBankInfoCN;
                var newBk = Model.bankInfoCN;
                // 如果新值跟原值不一样，则亮化提交按钮
                //改变国家
                if (oldBankInfoCN.country && oldBankInfoCN.country.value != Model.bankInfoCN.country.value ||
                    !oldBankInfoCN.country && Model.bankInfoCN.country.value) {
                    changed = true;
                } else if (Model.bankInfoCN.bank && (oldBankInfoCN.bank && oldBankInfoCN.bank.value != Model.bankInfoCN.bank.value || !oldBankInfoCN.bank && Model.bankInfoCN.bank.value)) {
                    changed = true;
                } else if (Model.bankInfoCN.province && (oldBankInfoCN.province && oldBankInfoCN.province.value != Model.bankInfoCN.province.value ||
                    !oldBankInfoCN.province && Model.bankInfoCN.province.value)) {
                    changed = true;
                } else if (Model.bankInfoCN.city && (oldBankInfoCN.city && oldBankInfoCN.city.value != Model.bankInfoCN.city.value ||
                    !oldBankInfoCN.city && Model.bankInfoCN.city.value)) {
                    changed = true;
                } else if (newBk.legalManVideoUrl && old.legalManVideoUrl && old.legalManVideoUrl != newBk.legalManVideoUrl || !old.legalManVideoUrl && newBk.legalManVideoUrl) {
                    changed = true;
                } else if (oldBankInfoCN.bankAccount != Model.bankInfoCN.bankAccount) {
                    changed = true;
                } else if (oldBankInfoCN.accountName != Model.bankInfoCN.accountName) {
                    changed = true;
                }
                $scope.isBankCNChanged = changed;
                return changed;
            }

            function operationInfo() {
                Model.operationInfoFlag = true
            }
        }]);
});

